export const DEFAULT_SKR03_CATEGORY_IDS = [
    800, 1590, 1800, 1820, 2020, 2090, 2100, 2110, 2120, 2130, 2140, 2150, 2170,
    2300, 2310, 2320, 2350, 2380, 2390, 2400, 2450, 2490, 2520, 2660, 3000,
    3010, 3030, 3100, 3120, 3160, 3200, 3300, 3400, 3700, 3710, 3720, 3730,
    3750, 3760, 3770, 3780, 3790, 3800, 3850, 4000, 4100, 4130, 4140, 4150,
    4160, 4170, 4180, 4190, 4200, 4210, 4220, 4230, 4240, 4250, 4260, 4270,
    4280, 4290, 4300, 4320, 4360, 4370, 4380, 4390, 4500, 4510, 4520, 4530,
    4540, 4550, 4560, 4570, 4580, 4590, 4600, 4630, 4640, 4660, 4670, 4673,
    4680, 4700, 4710, 4730, 4750, 4760, 4780, 4790, 4800, 4810, 4830, 4860,
    4870, 4900, 4910, 4920, 4930, 4940, 4950, 4960, 4970, 4980, 8000, 8100,
    8110, 8120, 8200, 8300, 8400, 8410, 8510, 8520, 8540, 8570, 8640, 8700,
    8710, 8720, 8730, 8750, 8760, 8770, 8780, 8790, 8800, 8820, 8910, 8920,
    8930, 8940, 8990,
]

export const SKR03_CATEGORIES = {
    '800': {
        id: '800',
        label: 'Gezeichnetes Kapital',
        description:
            'Kapitaleinzahlungen, z. B. die Stammkapitaleinzahlung bei der GmbH',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_REVENUE',
                id: 22,
                description: 'z.B. Durchlaufende Posten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '1525': {
        id: '1525',
        label: 'Kautionen',
        description: 'Gezahlte Kautionen z. B. für Büroräume',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '1588': {
        id: '1588',
        label: 'Einfuhrumsatzsteuer',
        description:
            'Von der deutschen Zollverwaltung erhobene Einfuhrumsatzsteuer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '1590': {
        id: '1590',
        label: 'Durchlaufende Posten',
        description:
            'Einnahmen, die weitergereicht werden und somit nicht ins Gewicht fallen',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
            {
                name: 'NICHT_STEUERBAR_REVENUE',
                id: 22,
                description: 'z.B. Durchlaufende Posten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE', 'EXPENSE'],
    },
    '1591': {
        id: '1591',
        label: 'Durchlaufende Posten',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '1800': {
        id: '1800',
        label: 'Privatentnahmen allgemein',
        description:
            'z. B. Entnahmen von Bargeld aus der Firmenkasse oder Bank für private Zwecke',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '1801': {
        id: '1801',
        label: 'Privatentnahmen allgemein (nur Einzelunternehmen)',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '1820': {
        id: '1820',
        label: 'Sonderausgaben beschränkt abzugsfähig',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '1821': {
        id: '1821',
        label: 'Sonderausgaben beschränkt abzugsfähig (nur Einzelunternehmen)',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2004': {
        id: '2004',
        label: 'Verluste durch Verschmelzung und Umwandlung',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2006': {
        id: '2006',
        label: 'Verluste durch außergewöhnliche Schadensfälle (nur Bilanzierer)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2007': {
        id: '2007',
        label: 'Aufwendungen für Restrukturierungs- und Sanierungsmaßnahmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2008': {
        id: '2008',
        label: 'Verluste aus der Veräußerung oder der Aufgabe von Geschäftsaktivitäten nach Steuern',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2020': {
        id: '2020',
        label: 'Periodenfremde Aufwendungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2090': {
        id: '2090',
        label: 'Aufwendungen aus der Anwendung von Übergangsvorschriften',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2091': {
        id: '2091',
        label: 'Aufwendungen aus der Anwendung von Übergangsvorschriften (Pensionsrückstellungen)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2094': {
        id: '2094',
        label: 'Aufwendungen aus der Anwendung von Übergangsvorschriften (latente Steuern)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2100': {
        id: '2100',
        label: 'Zinsen und ähnliche Aufwendungen',
        description: 'Sonstige Zinsaufwendungen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2102': {
        id: '2102',
        label: 'Nicht abzugsfähige andere Nebenleistungen § 4/5b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2103': {
        id: '2103',
        label: 'Abzugsfähige andere Nebenleistungen zu Steuern',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2104': {
        id: '2104',
        label: 'Nicht abzugsfähige andere Nebenleistungen z. Steuern',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2105': {
        id: '2105',
        label: 'Zinsaufwendungen § 233a AO nicht abzugsfähig',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2107': {
        id: '2107',
        label: 'Zinsaufwendungen § 233a AO abzugsfähig',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2108': {
        id: '2108',
        label: 'Zinsaufwendungen §§ 234 bis 237 AU nicht abzugsfähig',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2109': {
        id: '2109',
        label: 'Zinsaufwendungen an verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2110': {
        id: '2110',
        label: 'Zinsaufwendungen für kurzfristige Verbindlichkeiten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2111': {
        id: '2111',
        label: 'Zinsaufwendungen §§ 234 bis 237 AO abzugsfähig',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2113': {
        id: '2113',
        label: 'Nicht abzugsfähige Schuldzinsen nach § 4 Abs. 4a EStG (Hinzurechnungsbetrag)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2114': {
        id: '2114',
        label: 'Zinsen für Gesellschafterdarlehen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2115': {
        id: '2115',
        label: 'Zinsen und ähnliche Aufwendungen zu Teil nicht abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2116': {
        id: '2116',
        label: 'Zinsen und ähnliche Aufwendungen an verbundene Unternehmen §§ 3 Nr. 40 und 3c EStG bzw. § 8b Abs. 1 KStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2117': {
        id: '2117',
        label: 'Zinsen an Gesellschafter mit einer Beteiligung von mehr als 25 % bzw. diese nahestehenden Personen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2118': {
        id: '2118',
        label: 'Zinsen auf Kontokorrentkonten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2119': {
        id: '2119',
        label: 'Zinsaufwendungen für kurzfristige Verbindlichkeiten an verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2120': {
        id: '2120',
        label: 'Zinsaufwendungen für langfristige Verbindlichkeiten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2123': {
        id: '2123',
        label: 'Abschreibungen auf ein Agio oder Disagio/Damnum zur Finanzierung',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2124': {
        id: '2124',
        label: 'Abschreibungen auf ein Agio oder Disagio/Damnum zur Finanzierung des Anlagevermögens',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2125': {
        id: '2125',
        label: 'Zinsen für Gebäude im Betriebsvermögen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2126': {
        id: '2126',
        label: 'Zinsen zur Finanzierung Anlagevermögen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2127': {
        id: '2127',
        label: 'Renten und dauernde Lasten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2128': {
        id: '2128',
        label: 'Zinsaufwendungen für Kapitalüberlassung durch Mitunternehmer § 15 EstG (mit Sonderbetriebseinnahme korrespondierend)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2129': {
        id: '2129',
        label: 'Zinsaufwendungen für langfristige Verbindlichkeiten an verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2130': {
        id: '2130',
        label: 'Diskontaufwendungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2139': {
        id: '2139',
        label: 'Diskontaufwendungen an verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2140': {
        id: '2140',
        label: 'Zinsähnliche Aufwendungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2141': {
        id: '2141',
        label: 'Kreditprovisionen und Verwaltungskostenbeiträge',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2142': {
        id: '2142',
        label: 'Zinsanteil der Zuführungen zu Pensionsrückstellungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2143': {
        id: '2143',
        label: 'Zinsaufwendungen aus der Abzinsung von Verbindlichkeiten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2144': {
        id: '2144',
        label: 'Zinsaufwendungen aus der Abzinsung von Rückstellungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2145': {
        id: '2145',
        label: 'Zinsaufwendungen aus der Abzinsung von Pensionsrückstellungen und ähnlichen/vergleichbaren Verpflichtungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2146': {
        id: '2146',
        label: 'Zinsaufwendungen aus der Abzinsung von Pensionsrückstellungen und ähnlichen/vergleichbaren Verpflichtungen zur Verrechnung nach § 246 Abs. 2 HGB',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2147': {
        id: '2147',
        label: 'Aufwendungen aus Vermögensgegenständen zur Verrechnung nach § 246 Abs. 2 HGB',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2148': {
        id: '2148',
        label: 'Steuerlich nicht abzugsfähige Zinsaufwendungen aus der Abzinsung von Rückstellungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2149': {
        id: '2149',
        label: 'Zinsähnliche Aufwendungen an verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2150': {
        id: '2150',
        label: 'Aufwendungen aus Währungsumrechnung',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2170': {
        id: '2170',
        label: 'NIcht abziehbare Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2171': {
        id: '2171',
        label: 'Nicht abziehbare Vorsteuer 7 %',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2176': {
        id: '2176',
        label: 'Nicht abziehbare Vorsteuer 19 %',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2219': {
        id: '2219',
        label: 'Anrechnung / Abzug ausländische Quellensteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2300': {
        id: '2300',
        label: 'Sonstige betriebliche Aufwendungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2307': {
        id: '2307',
        label: 'Sonstige Aufwendungen, betriebsfremd und regelmäßig',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2308': {
        id: '2308',
        label: 'Sonstige nicht abziehbare Aufwendungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2309': {
        id: '2309',
        label: 'Sonstige Aufwendungen unregelmäßig',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2310': {
        id: '2310',
        label: 'Abgänge Sachanlagen Restbuchwert bei BV',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2311': {
        id: '2311',
        label: 'Abgang immaterielle Vermögensgegenstände RBW, BV',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2315': {
        id: '2315',
        label: 'Abgänge Sachanlagen Restbuchwert bei BG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2317': {
        id: '2317',
        label: 'Abgänge Finanzanlagen Restbuchwert BG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2318': {
        id: '2318',
        label: 'Abgänge Finanzanlagen RBW z.T. Stf., BG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2320': {
        id: '2320',
        label: 'Verluste aus Anlagenabgang',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2327': {
        id: '2327',
        label: 'Abgang von WG des Umlaufvermögens § 4 Abs.3 Satz EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2328': {
        id: '2328',
        label: 'Abgang von WG des Umlaufvermögens § 3 Nr. 40 EStG bzw. § 8b Abs. 3 KStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2350': {
        id: '2350',
        label: 'Sonstige Grundstücksaufwendungen neutral',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2380': {
        id: '2380',
        label: 'Zuwendungen, Spenden steuerlich nicht abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2381': {
        id: '2381',
        label: 'Zuwendungen, Spenden für wissenschaftliche und kulturelle Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2382': {
        id: '2382',
        label: 'Zuwendungen, Spenden für mildtätige Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2383': {
        id: '2383',
        label: 'Zuwendungen, Spenden für kirchliche,religiöse und gemeinnützige Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2384': {
        id: '2384',
        label: 'Zuwendungen, Spenden an politische Partei',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2385': {
        id: '2385',
        label: 'Nicht abziehbare Aufsichtsratsvergütungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2387': {
        id: '2387',
        label: 'Zuwendungen, Spenden an Stiftungen gemeinnützige Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2389': {
        id: '2389',
        label: 'Zuwendungen, Spenden an Stiftungen kirchliche, religiöse und gemeinnützige Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2390': {
        id: '2390',
        label: 'Zuwendungen, Spenden an Stiftungen wissenschaftliche, mildtätige und kulturelle Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2400': {
        id: '2400',
        label: 'Forderungsverluste',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2401': {
        id: '2401',
        label: 'Forderungsverlust 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2403': {
        id: '2403',
        label: 'Forderungsverluste EU-Lieferungen 7 %',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2406': {
        id: '2406',
        label: 'Forderungsverluste 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2430': {
        id: '2430',
        label: 'Forderungsverluste',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2431': {
        id: '2431',
        label: 'Forderungsverluste 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2436': {
        id: '2436',
        label: 'Forderungsverluste 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2450': {
        id: '2450',
        label: 'Einstellungen in die Pauschalwertberichtigung auf Forderungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2451': {
        id: '2451',
        label: 'Einstellung in die Einzelwertberichtigung auf Forderungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2490': {
        id: '2490',
        label: 'Aufwendungen aus Verlustübernahme',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2492': {
        id: '2492',
        label: 'Abgeführte Gewinne auf Grund einer Gewinngemeinschaft',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2493': {
        id: '2493',
        label: 'Abgeführte Gewinnanteile (Soll) / ausgeglichene Verlustanteile (Haben) bei typisch stiller Beteiligung § 8 GewStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2494': {
        id: '2494',
        label: 'Abgeführte Gewinne auf Grund eines Gewinn- oder Teilgewinnabführungsvertrags',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2520': {
        id: '2520',
        label: 'Periodenfremde Erträge (soweit nicht außerordentlich)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2660': {
        id: '2660',
        label: 'Erträge aus der Währungsumrechnung',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2705': {
        id: '2705',
        label: 'Sonstige betriebl. Regelm. Erträge',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2707': {
        id: '2707',
        label: 'Sonstige Erträge betriebsfremd und regelmäßig',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2709': {
        id: '2709',
        label: 'Sonstige Erträge unregelmäßig',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2732': {
        id: '2732',
        label: 'Erträge aus abgeschriebenen Forderungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2743': {
        id: '2743',
        label: 'Investitionszuschüsse',
        description: 'z. B. Coronahilfen',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_TAX',
                id: 15,
                description:
                    'z.B. Umsatzsteuervorauszahlungen oder Umsatzsteuerrückerstattung',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2747': {
        id: '2747',
        label: 'Sonstige steuerfreie Betriebseinnahmen (ohne steuerfreie Sanierungserträge nach § 3a EStG)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2750': {
        id: '2750',
        label: 'Grundstückserträge',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2752': {
        id: '2752',
        label: 'Erlöse aus Vermietung und Verpachtung 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '2762': {
        id: '2762',
        label: 'Kostenerstattungen, Rückvergütungen und Gutschriften für frühere Jahre',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '3000': {
        id: '3000',
        label: 'Einkauf Roh-, Hilfs und Betriebsstoffe',
        description: 'Kosten für Material zur Weiterverarbeitung',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3010': {
        id: '3010',
        label: 'Einkauf Roh-, Hilfs und Betriebsstoffe 7 %  Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3030': {
        id: '3030',
        label: 'Einkauf Roh-, Hilfs und Betriebsstoffe 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3100': {
        id: '3100',
        label: 'Fremdleistungen',
        description: 'Kosten für Subunternehmer und Externe, z. B. Werbetexter',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3106': {
        id: '3106',
        label: 'Fremdleistungen 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3108': {
        id: '3108',
        label: 'Fremdleistungen 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3120': {
        id: '3120',
        label: 'Bauleistungen eines im Inland ansässigen Unternehmers zum allgemeinen Vor- und Umsatzsteuersatz',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3123': {
        id: '3123',
        label: 'Sonstige Leistungen eines im anderen EU-Land ansässigen Unternehmers zum allgemeinen Vorsteuer- und Umsatzsteuersatz',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3125': {
        id: '3125',
        label: 'Leistungen eines im Ausland ansässigen Unternehmers zum allgemeinen Vorsteuer- und Umsatzsteuersatz',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3160': {
        id: '3160',
        label: 'Leistungen § 13b mit Vorsteuerabzug',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3165': {
        id: '3165',
        label: 'Leistungen § 13b ohne Vorsteuerabzug',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3200': {
        id: '3200',
        label: 'Wareneingang',
        description: 'Kosten für gekaufte Waren',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3300': {
        id: '3300',
        label: 'Wareneingang 7 % VSt',
        description: 'Kosten für gekaufte Waren mit 7 %',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3301': {
        id: '3301',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3302': {
        id: '3302',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3303': {
        id: '3303',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3304': {
        id: '3304',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3305': {
        id: '3305',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3306': {
        id: '3306',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3307': {
        id: '3307',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3308': {
        id: '3308',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3309': {
        id: '3309',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3349': {
        id: '3349',
        label: 'Wareneingang ohne Vorsteuerabzug',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3400': {
        id: '3400',
        label: 'Wareneingang 19 % Vorsteuer',
        description: 'Kosten für gekaufte Waren mit 19 %',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3401': {
        id: '3401',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3402': {
        id: '3402',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3403': {
        id: '3403',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3404': {
        id: '3404',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3405': {
        id: '3405',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3406': {
        id: '3406',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3407': {
        id: '3407',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3408': {
        id: '3408',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3409': {
        id: '3409',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3418': {
        id: '3418',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3425': {
        id: '3425',
        label: 'Innergemeinschaftlicher Erwerb 19 % Vorsteuer und 19 % Umsatzsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3426': {
        id: '3426',
        label: 'Innergemeinschaftlicher Erwerb 19 % Vorsteuer und 19 % Umsatzsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3427': {
        id: '3427',
        label: 'Innergemeinschaftlicher Erwerb 19 % Vorsteuer und 19 % Umsatzsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3428': {
        id: '3428',
        label: 'Innergemeinschaftlicher Erwerb 19 % Vorsteuer und 19 % Umsatzsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3429': {
        id: '3429',
        label: 'Innergemeinschaftlicher Erwerb 19 % Vorsteuer und 19 % Umsatzsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3559': {
        id: '3559',
        label: 'Steuerfreie Einfuhren',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3700': {
        id: '3700',
        label: 'Nachlässe',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3701': {
        id: '3701',
        label: 'Nachlässe und Einkauf RHB',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3710': {
        id: '3710',
        label: 'Nachlässe 7 %  Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3714': {
        id: '3714',
        label: 'Nachlässe aus Einkauf Roh-, Hilfs- und Betriebsstoffe 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3715': {
        id: '3715',
        label: 'Nachlässe aus Einkauf Roh-, Hilfs- und Betriebsstoffe 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3720': {
        id: '3720',
        label: 'Nachlässe 19 %  Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3730': {
        id: '3730',
        label: 'Erhaltene Skonti',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3731': {
        id: '3731',
        label: 'Erhaltene Skonti 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3733': {
        id: '3733',
        label: 'Erhaltene Skonti Einkauf RHB',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3734': {
        id: '3734',
        label: 'Erhaltene Skonti Einkauf RHB 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3736': {
        id: '3736',
        label: 'Erhaltene Skonti 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3738': {
        id: '3738',
        label: 'Erhaltene Skonti Einkauf RHB 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3744': {
        id: '3744',
        label: 'Erhaltene Skonti aus Einkauf Roh-, Hilfs- und Betriebsstoffe aus steuerpflichtigem innergemeinschaftlichem Erwerb',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3745': {
        id: '3745',
        label: 'Erhaltene Skonti aus steuerpflichtigem innergemeinschaftlichem Erwerb',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3750': {
        id: '3750',
        label: 'Erhaltene Boni 7 %  Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3753': {
        id: '3753',
        label: 'Erhaltene Boni aus Einkauf RHB',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3754': {
        id: '3754',
        label: 'Erhaltene Boni aus Einkauf Roh-, Hilfs- und Betriebsstoffen 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3755': {
        id: '3755',
        label: 'Erhaltene Boni aus Einkauf Roh-, Hilfs- und Betriebsstoffen 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3760': {
        id: '3760',
        label: 'Erhaltene Boni 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3769': {
        id: '3769',
        label: 'Erhaltene Boni',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3770': {
        id: '3770',
        label: 'Erhaltene Rabatte',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3780': {
        id: '3780',
        label: 'Erhaltene Rabatte 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3783': {
        id: '3783',
        label: 'Erhaltene Rabatte auf Einkauf RHB',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3784': {
        id: '3784',
        label: 'Erhaltene Rabatte auf Einkauf Roh-, Hilfs- und Betriebsstoffen 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3785': {
        id: '3785',
        label: 'Erhaltene Rabatte auf Einkauf Roh-, Hilfs- und Betriebsstoffen 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3790': {
        id: '3790',
        label: 'Erhaltene Rabatte 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3800': {
        id: '3800',
        label: 'Bezugsnebenkosten',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3830': {
        id: '3830',
        label: 'Leergut',
        description: 'z. B. Paletten',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '3850': {
        id: '3850',
        label: 'Zölle und Einfuhrabgaben',
        description:
            'Ausgaben für die Einfuhr von Waren, z. B. Zollgebühren, Bereitstellungsprovisionen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4000': {
        id: '4000',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4001': {
        id: '4001',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4002': {
        id: '4002',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4003': {
        id: '4003',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4004': {
        id: '4004',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4005': {
        id: '4005',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4006': {
        id: '4006',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4007': {
        id: '4007',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4008': {
        id: '4008',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4009': {
        id: '4009',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4010': {
        id: '4010',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4011': {
        id: '4011',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4012': {
        id: '4012',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4013': {
        id: '4013',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4014': {
        id: '4014',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4015': {
        id: '4015',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4016': {
        id: '4016',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4017': {
        id: '4017',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4018': {
        id: '4018',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4019': {
        id: '4019',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4020': {
        id: '4020',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4021': {
        id: '4021',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4022': {
        id: '4022',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4023': {
        id: '4023',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4024': {
        id: '4024',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4025': {
        id: '4025',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4026': {
        id: '4026',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4027': {
        id: '4027',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4028': {
        id: '4028',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4029': {
        id: '4029',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4030': {
        id: '4030',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4031': {
        id: '4031',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4032': {
        id: '4032',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4033': {
        id: '4033',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4034': {
        id: '4034',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4035': {
        id: '4035',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4036': {
        id: '4036',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4037': {
        id: '4037',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4038': {
        id: '4038',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4039': {
        id: '4039',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4040': {
        id: '4040',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4041': {
        id: '4041',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4042': {
        id: '4042',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4043': {
        id: '4043',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4044': {
        id: '4044',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4045': {
        id: '4045',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4046': {
        id: '4046',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4047': {
        id: '4047',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4048': {
        id: '4048',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4049': {
        id: '4049',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4050': {
        id: '4050',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4051': {
        id: '4051',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4052': {
        id: '4052',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4053': {
        id: '4053',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4054': {
        id: '4054',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4055': {
        id: '4055',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4056': {
        id: '4056',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4057': {
        id: '4057',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4058': {
        id: '4058',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4059': {
        id: '4059',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4060': {
        id: '4060',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4061': {
        id: '4061',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4062': {
        id: '4062',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4063': {
        id: '4063',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4064': {
        id: '4064',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4065': {
        id: '4065',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4066': {
        id: '4066',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4067': {
        id: '4067',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4068': {
        id: '4068',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4069': {
        id: '4069',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4070': {
        id: '4070',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4071': {
        id: '4071',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4072': {
        id: '4072',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4073': {
        id: '4073',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4074': {
        id: '4074',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4075': {
        id: '4075',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4076': {
        id: '4076',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4077': {
        id: '4077',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4078': {
        id: '4078',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4079': {
        id: '4079',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4080': {
        id: '4080',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4081': {
        id: '4081',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4082': {
        id: '4082',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4083': {
        id: '4083',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4084': {
        id: '4084',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4085': {
        id: '4085',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4086': {
        id: '4086',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4087': {
        id: '4087',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4088': {
        id: '4088',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4089': {
        id: '4089',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4090': {
        id: '4090',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4091': {
        id: '4091',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4092': {
        id: '4092',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4093': {
        id: '4093',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4094': {
        id: '4094',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4095': {
        id: '4095',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4096': {
        id: '4096',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4097': {
        id: '4097',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4098': {
        id: '4098',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4099': {
        id: '4099',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4100': {
        id: '4100',
        label: 'Löhne und Gehälter',
        description: 'Kosten für Löhne und Gehälter von Mitarbeitern',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4110': {
        id: '4110',
        label: 'Löhne',
        description: 'Kosten für Löhne von Mitarbeitern',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4120': {
        id: '4120',
        label: 'Gehälter',
        description: 'Kosten für Gehälter von Mitarbeitern',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4124': {
        id: '4124',
        label: 'Geschaftsführergehälter GmbH-Gesellschafter',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4125': {
        id: '4125',
        label: 'Ehegattengehalt',
        description: 'Kosten für Gehälter an verheiratete Lebenspartner',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4127': {
        id: '4127',
        label: 'Geschäftsführergehälter',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4128': {
        id: '4128',
        label: 'Vergütungen an Mitunternehmer § 15 EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4129': {
        id: '4129',
        label: 'Tantieme Arbeitnehmer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4130': {
        id: '4130',
        label: 'Gesetzliche Sozialaufwendungen',
        description: 'Beiträge zur Krankenkasse',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4138': {
        id: '4138',
        label: 'Beiträge zur Berufsgenossenschaft',
        description: 'Beiträge zur Berufsgenossenschaft (BG)',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4139': {
        id: '4139',
        label: 'Ausgleichsabgabe SchwerbehindertenG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4140': {
        id: '4140',
        label: 'Freiwillige soziale Aufwendungen lohnsteuerfrei',
        description: 'Freiwillige lohnsteuerfreie Aufwendungen an Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4141': {
        id: '4141',
        label: 'Sonstige soziale Abgaben',
        description:
            'Sonstige soziale Abgaben an Arbeitnehmer, die nicht anderen Konten zugeordnet werden können',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4144': {
        id: '4144',
        label: 'Soziale Abgaben für Minijobber',
        description: 'Aufwendungen für die sozialen Abgaben an Minijobber',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4145': {
        id: '4145',
        label: 'Freiwiliige soziale Aufwendungen lohnsteuerpflichtig',
        description:
            'Freiwillige lohnsteuerpflichtige Aufwendungen an Arbeitnehmer, z. B. wenn der monatliche Betrag vom Gutschein die LSt-freie Grenze von 50 € übersteigt',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4146': {
        id: '4146',
        label: 'Freiwillige Zuwendungen an Minijobber',
        description: 'Freiwillige Aufwendungen an Minijobber',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4149': {
        id: '4149',
        label: 'Pauschale Steuer aus sonstige Bezüge',
        description:
            'Kosten für die pauschale Besteuerung von sonstigen Bezügen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4150': {
        id: '4150',
        label: 'Krankengeldzuschüsse',
        description: 'Zuschüsse der Krankenkassen für Krankengelder',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4151': {
        id: '4151',
        label: 'Sachzuwendungen und Dienstleistungen Minijob',
        description:
            'z. B. Geschenke an Minijobber, die die SV- und LSt-Grenzen überschreiten und deswegen mit 30 % pauschal besteuert wurden',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4152': {
        id: '4152',
        label: 'Sachzuwendungen und Dienstleistungen an Arbeitnehmer',
        description:
            'z. B. Geschenke an Arbeitnehmer, die die SV- und LSt-Grenzen überschreiten und deswegen mit 30 % pauschal besteuert wurden',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4155': {
        id: '4155',
        label: 'Zuschüsse Agenturen für Arbeit',
        description:
            'Förderungen der Agentur für Arbeit für die Aufnahme von z. B. älteren oder behinderten Arbeitnehmern',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4160': {
        id: '4160',
        label: 'Versorgungskassen',
        description: 'Aufwendungen an die Versorgungskasse',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4165': {
        id: '4165',
        label: 'Aufwendungen für Altersversorgung',
        description: 'Aufwendungen für Altersvorsorgeverträge der Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4166': {
        id: '4166',
        label: 'Aufwendungen Altersversorgung Gesellschafter-Geschäftsführer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4167': {
        id: '4167',
        label: 'Pauschale Steuer für versicherungen',
        description:
            'Pauschale Steuer auf Versicherungsverträge der Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4168': {
        id: '4168',
        label: 'Aufwendungen Altersversorgung für Mitunternehmer § 15 EStg',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4169': {
        id: '4169',
        label: 'Aufwendungen für Unterstützung',
        description: 'Aufwendungen für Unterstützungen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4170': {
        id: '4170',
        label: 'Vermögenswirksame Leistungen',
        description: 'Aufwendungen für VWL-Verträge der Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4175': {
        id: '4175',
        label: 'Fahrtkostenerstattung Whg./Arbeitsstätte',
        description:
            'Erstattung der Kosten an Arbeitnehmer für Fahrten zwischen Wohn- und Arbeitsstätte',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4180': {
        id: '4180',
        label: 'Bedienungsgelder',
        description: 'Trinkgelder für Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4190': {
        id: '4190',
        label: 'Aushilfslöhne',
        description: 'Kosten für Aushilfen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4194': {
        id: '4194',
        label: 'Pauschale Steuern Minijobber',
        description: 'Kosten für die pauschale Besteuerung von Minijobbern',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4195': {
        id: '4195',
        label: 'Löhne für Minijobs',
        description: 'Kosten für Minijobber',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4199': {
        id: '4199',
        label: 'Pauschale Steuer für Aushilfen',
        description: 'Kosten für die pauschale Besteuerung von Aushilfen',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4200': {
        id: '4200',
        label: 'Raumkosten',
        description:
            'Sonstige Kosten für betriebliche Räume, die sich keiner anderen Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4210': {
        id: '4210',
        label: 'Miete, unbewegliche Wirtschaftsgüter',
        description: 'Kosten für die Miete oder Pacht von Räumlichkeiten',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4211': {
        id: '4211',
        label: 'Aufwendungen für unbewegliche Wirtschaftsgüter (GewSt hinzuzurechnen)',
        description: 'Sonstige Aufwendungen für unbewegliche Wirtschaftsgüter',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4212': {
        id: '4212',
        label: 'Miete/Aufwendungen für doppelte Haushaltsführung Unternehmer',
        description: 'Aufwendungen für eine zweite Wohnung für den Unternehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4215': {
        id: '4215',
        label: 'Leasing, unbewegliche Wirtschaftsgüter',
        description:
            'Leasingaufwendungen für unbewegliche Gegenstände (z.B. fest verankerte Maschinen)',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4220': {
        id: '4220',
        label: 'Pacht, unbewegliche Wirtschaftsgüter',
        description: 'z.B. die monatlich gezahlte Pacht für ein Grundstück',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4228': {
        id: '4228',
        label: 'Miet- und Pachtnebenkosten',
        description: 'Nebenkosten für gemietete oder gepachtete Objekte',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4230': {
        id: '4230',
        label: 'Heizung',
        description: 'Aufwendungen für Heizkosten',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4240': {
        id: '4240',
        label: 'Gas, Strom, Wasser',
        description: 'Nebenkosten, z.B. die E-Werk-Rechnung',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4250': {
        id: '4250',
        label: 'Reinigung',
        description: 'Kosten für Reinigungsmittel',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4260': {
        id: '4260',
        label: 'Instandhaltung betrieblicher Räume',
        description: 'z.B. Renovierungsarbeiten',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4270': {
        id: '4270',
        label: 'Abgaben betrieblich genutzter Grundbesitz',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4280': {
        id: '4280',
        label: 'Sonstige Raumkosten',
        description:
            'Sonstige Kosten für betriebliche Räume, die sich keiner Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4288': {
        id: '4288',
        label: 'Aufwendungen für ein häusliches Arbeitszimmer (Abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4289': {
        id: '4289',
        label: 'Aufwendungen für ein häusliches Arbeitszimmer (nicht abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4290': {
        id: '4290',
        label: 'Grundstücksaufwendungen, betrieblich',
        description: 'Sonstige Kosten für das betriebliche Grundstück',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4300': {
        id: '4300',
        label: 'Nicht abziehbare Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4301': {
        id: '4301',
        label: 'Nicht abziehbare Vorsteuer 7 %',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4306': {
        id: '4306',
        label: 'Nicht abziehbare Vorsteuer 19 %',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4320': {
        id: '4320',
        label: 'Gewerbesteuer',
        description: 'Die an die Gemeinde zu entrichtende Gewerbesteuer',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4360': {
        id: '4360',
        label: 'Versicherung',
        description: 'Kosten für betriebliche Versicherungen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4366': {
        id: '4366',
        label: 'Versicherung für Gebäude',
        description: 'Kosten für die betriebliche Versicherung von Gebäuden',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4370': {
        id: '4370',
        label: 'Prämie Rückdeckung für Versorgungsleistungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4380': {
        id: '4380',
        label: 'Beiträge',
        description: 'Beitragsgebühren z.B. für Kammergebühren',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4390': {
        id: '4390',
        label: 'Sonstige Abgaben',
        description: 'Sonstige Abgaben',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4396': {
        id: '4396',
        label: 'Abzugsf. Verspätungszuschlag/ Zwangsgeld',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4397': {
        id: '4397',
        label: 'Nicht abzugsfähige Verspätungszuschläge/ Zwangsgelder',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4500': {
        id: '4500',
        label: 'Fahrzeugkosten',
        description: 'Sonstige Kosten im Zusammenhang mit einem Fahrzeug',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4510': {
        id: '4510',
        label: 'KFZ-Steuern',
        description: 'Zu zahlende Steuern für Fahrzeuge',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4520': {
        id: '4520',
        label: 'KFZ-Versicherung',
        description: 'Kosten für die Versicherung von Fahrzeugen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4530': {
        id: '4530',
        label: 'Laufende KFZ-Betriebskosten',
        description:
            'Kosten für Kraftstoffe und die Wagenpflege, z.B. Waschanlage',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4540': {
        id: '4540',
        label: 'KFZ-Reparaturen',
        description:
            'Kosten für Reparatur eines Fahrzeugs, Kundenservices etc.',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4550': {
        id: '4550',
        label: 'Garagenmieten',
        description: 'Kosten für Garagen und Parkplätze',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4560': {
        id: '4560',
        label: 'Mautgebühren',
        description: 'z.B. Vignette, Autobahngebühren',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4570': {
        id: '4570',
        label: 'Mietleasing Kfz',
        description: 'Gebühren für Leasingfahrzeuge',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4575': {
        id: '4575',
        label: 'Mietleasingaufw. für Elektrofzg. die gewerbesteuerlich hinzuzurechnen sind',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4580': {
        id: '4580',
        label: 'Sonstige Kfz-Kosten',
        description: 'Sonstige Kosten im Zusammenhang mit einem Fahrzeug',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4590': {
        id: '4590',
        label: 'Kfz-Kosten für betrieblich genutzte zum Privatvermögen gehörende Kraftfahrzeuge',
        description: 'Gebühren für Mietwagen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4595': {
        id: '4595',
        label: 'Fremdfahrzeugkosten',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4600': {
        id: '4600',
        label: 'Werbekosten',
        description: 'Kosten für Werbeschaltungen, Messen und Werbemittel',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4605': {
        id: '4605',
        label: 'Streuartikel',
        description: 'Aufwendungen für die Kundenpflege',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4630': {
        id: '4630',
        label: 'Geschenke abzugsfähig ohne § 37b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4631': {
        id: '4631',
        label: 'Geschenke abzugsfähig mit § 37b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4632': {
        id: '4632',
        label: 'Pauschale Steuern für Zuwendungen nicht abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4635': {
        id: '4635',
        label: 'Geschenke nicht abzugsfähig ohne § 37b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4636': {
        id: '4636',
        label: 'Geschenke nicht abzugsfähig mit § 37b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4637': {
        id: '4637',
        label: 'Pauschale Steuern Geschenke/Zugaben abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4638': {
        id: '4638',
        label: 'Geschenke ausschließlich betrieblich genutzt',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4639': {
        id: '4639',
        label: 'Zugaben mit § 37b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4640': {
        id: '4640',
        label: 'Repräsentationskosten',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4651': {
        id: '4651',
        label: 'Sonstige eingeschränkt abziehbare Betriebsausgaben (abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4652': {
        id: '4652',
        label: 'Sonstige eingeschränkt abziehbare Betriebsausgaben (nicht abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4653': {
        id: '4653',
        label: 'Aufmerksamkeiten',
        description: 'z.B. Getränke, Häppchen etc.',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4655': {
        id: '4655',
        label: 'Nicht abzugsfähige Betriebsausgaben',
        description: 'z.B. Verwarnungsgelder',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4660': {
        id: '4660',
        label: 'Reisekosten Arbeitnehmer',
        description:
            'Sonstige Kosten für betrieblich veranlasste Reisen der Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4663': {
        id: '4663',
        label: 'Reisekosten Arbeitnehmer Fahrtkosten',
        description:
            'Fahrtkosten für betrieblich veranlasste Reisen der Arbeitnehmer z.B. Taxi',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4664': {
        id: '4664',
        label: 'Reisekosten AN Verpflegungsmehraufwand',
        description:
            'Spesen für zusätzlich entstandene Kosten auf Geschäftsreisen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4666': {
        id: '4666',
        label: 'Reisekosten AN Übernachtungsaufwand',
        description:
            'Übernachtungsaufwendungen für betrieblich veranlasste Reisen der Arbeitnehmer, z.B Hotelkosten',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4668': {
        id: '4668',
        label: 'Kilometergelderstattung Arbeitnehmer',
        description:
            'Erstattung der gefahrenen Kilometer (mit dem privaten PKW) der Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4670': {
        id: '4670',
        label: 'Reisekosten Unternehmer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4672': {
        id: '4672',
        label: 'Reisekosten Unternehmer (nicht abziehbarer Anteil)',
        description: 'nicht abziehbare Reisekosten des Unternehmers',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4673': {
        id: '4673',
        label: 'Reisekosten Unternehmer Fahrtkosten',
        description: 'Kosten für betriebliche Fahrten, Taxifahrten etc.',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4674': {
        id: '4674',
        label: 'Reisekosten Unternehmer Verpflegungsmehraufwand',
        description:
            'Spesen für zusätzlich entstandene Kosten auf Geschäftsreisen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4676': {
        id: '4676',
        label: 'Reisekosten Unternehmer Übernachtungsaufwand und Reisenebenkosten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4678': {
        id: '4678',
        label: 'Fahrten zwischen Wohn und Betriebsstätte und Familienheimfahrten (abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4679': {
        id: '4679',
        label: 'Fahrten zwischen Wohn und Betriebsstätte und Familienheimfahrten (nicht abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4680': {
        id: '4680',
        label: 'Fahrten zwischen Wohn und Betriebsstätte und Familienheimfahrten (Haben)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4681': {
        id: '4681',
        label: 'Verpflegungsmehraufwendungen im Rahmen der doppelten Haushaltsführung Unternehmer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4700': {
        id: '4700',
        label: 'Kosten Warenabgabe',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4710': {
        id: '4710',
        label: 'Verpackungsmaterial',
        description: 'Aufwendungen für die Verpackung z.B. Kartonagen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4730': {
        id: '4730',
        label: 'Ausgangsfrachten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4750': {
        id: '4750',
        label: 'Transportversicherungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4760': {
        id: '4760',
        label: 'Verkaufsprovisionen',
        description: 'Provisionszahlungen für externe Vertriebler',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4780': {
        id: '4780',
        label: 'Fremdarbeiten (Vertrieb)',
        description: 'Aufwendungen für externe Vertriebler',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4790': {
        id: '4790',
        label: 'Aufwand für Gewährleistungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4800': {
        id: '4800',
        label: 'Reparatur und Instandhaltungen Anlagen u. Maschinen',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4801': {
        id: '4801',
        label: 'Reparatur und Instandhaltungen von Bauten',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4805': {
        id: '4805',
        label: 'Reparatur und Instandhaltung Anlagen, Betriebs- und Geschäftsausstattung',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4806': {
        id: '4806',
        label: 'Wartungskosten für Hard- und Software',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4808': {
        id: '4808',
        label: 'Zuführung zu Aufwandsrückstellungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4809': {
        id: '4809',
        label: 'Sonstige Reparaturen/Instandhaltung',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4810': {
        id: '4810',
        label: 'Mietleasing bewegliche WG technische Anlagen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4815': {
        id: '4815',
        label: 'Kaufleasing',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4822': {
        id: '4822',
        label: 'Abschreibungen immaterielle VermG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4823': {
        id: '4823',
        label: 'Abschreibungen auf selbst geschaffene immaterielle Vermögensgegenstände',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4824': {
        id: '4824',
        label: 'Abschreibung Geschäfts- oder Firmenwert',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4830': {
        id: '4830',
        label: 'Abschreibungen auf Sachanlagen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4831': {
        id: '4831',
        label: 'Abschreibungen auf Gebäude',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4832': {
        id: '4832',
        label: 'Abschreibungen auf KFZ',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4851': {
        id: '4851',
        label: 'Sonderabschreibungen § 7g Abs.5 EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4852': {
        id: '4852',
        label: 'Sonderabschreibungen KFZ § 7g Abs. 5 EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4855': {
        id: '4855',
        label: 'Sofortabschreibung GWG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4856': {
        id: '4856',
        label: 'Sonderabschreibungen § 7b EStG (Mietwohnungsneubau)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4860': {
        id: '4860',
        label: 'Abschreibungen auf aktivierte GWG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4862': {
        id: '4862',
        label: 'Abschreibungen auf WG Sammelposten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4866': {
        id: '4866',
        label: 'Abschreibungen aus Finanzanlagen (nicht dauerhaft)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4870': {
        id: '4870',
        label: 'Abschreibungen auf Finanzanlagen (dauerhaft)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4871': {
        id: '4871',
        label: 'Abschreibungen auf Finanzanlagen § 3 Nr. 40 EStG bzw. § 8b Abs. 3 KStG (dauerhaft)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4872': {
        id: '4872',
        label: 'Aufwendungen auf Grund von Verlustanteilen an gewerblichen und selbständigen Mitunternehmerschaften, § 8 GewStG bzw. § 18 EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4873': {
        id: '4873',
        label: 'Abschreibungen auf Finanzanlagen auf Grund § 6b EStG-Rücklage, § 3 Nr. 40 EStG bzw. § 8b Abs. 3 KStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4874': {
        id: '4874',
        label: 'Abschreibungen auf Finanzanlagen auf Grund § 6b EStG-Rücklage',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4875': {
        id: '4875',
        label: 'Abschreibungen Wertpapiere des Umlaufvermögens',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4876': {
        id: '4876',
        label: 'Abschreibungen Wertpapiere Umlaufvermögens z.T. nicht abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4877': {
        id: '4877',
        label: 'Abschreibungen auf Finanzanlagen - verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4878': {
        id: '4878',
        label: 'Abschreibungen auf Wertpapiere des Umlaufvermögens, verb. UN',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4882': {
        id: '4882',
        label: 'Abschreibungen auf Umlaufvermögen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4900': {
        id: '4900',
        label: 'sonstige betriebliche Aufwendungen',
        description:
            'Kosten für sonstige Anschaffungen, die sich keiner Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4902': {
        id: '4902',
        label: 'Interimskonto für Aufwendungen in einem anderen Land, bei denen eine Vorsteuervergütung möglich ist',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4905': {
        id: '4905',
        label: 'Sonstige betriebliche und regelmäßige Aufwendungen',
        description:
            'Aufwendungen, die regelmäßig dem allgemeinen Geschäftsbetrieb dienen und sich keiner anderen Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4909': {
        id: '4909',
        label: 'Fremdleistungen und Fremdarbeiten',
        description:
            'Fremdleistungen, die dem allgemeinen Geschäftsbetrieb dienen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4910': {
        id: '4910',
        label: 'Porto',
        description: 'z.B. Briefmarken oder Paketscheine',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4920': {
        id: '4920',
        label: 'Telefon',
        description: 'Kosten für den Festnetzanschluss oder Handyvertrag',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4925': {
        id: '4925',
        label: 'Telefax und Internetkosten',
        description: 'Kosten für den Internetzugang',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4930': {
        id: '4930',
        label: 'Bürobedarf',
        description: 'z.B. Papier, Stifte und Blöcke',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4940': {
        id: '4940',
        label: 'Zeitschriften, Bücher (Fachliteratur)',
        description: 'z.B. Fachzeitschriften oder Lektüren',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4945': {
        id: '4945',
        label: 'Fortbildungskosten',
        description: 'Kosten für Weiterbildungsmaßnahmen, z.B. Kursgebühren',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4946': {
        id: '4946',
        label: 'Freiwillige Sozialleistungen',
        description: 'Sozialleistungen, die keinen Arbeitslohn darstellen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4949': {
        id: '4949',
        label: 'Haftungsvergütung an Mitunternehmer § 15 EStG (mit Sonderbetriebseinnahme korrespondierend)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4950': {
        id: '4950',
        label: 'Rechts- und Beratungskosten',
        description: 'Kosten für Rechtsberatung',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4955': {
        id: '4955',
        label: 'Buchführungskosten',
        description:
            'Kosten für die laufende Buchhaltung, z.B. Kosten vom Buchhaltungsbüro',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4957': {
        id: '4957',
        label: 'Abschluss- und Prüfungskosten',
        description:
            'Kosten für Abschlüsse, Prüfungen und Steuerberatung im Allgemeinen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4960': {
        id: '4960',
        label: 'Mieten für Einrichtungen bewegliche WG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4961': {
        id: '4961',
        label: 'Pacht (bewegliche Wirtschaftsgüter)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4963': {
        id: '4963',
        label: 'Aufwendungen für bewegliche Wirtschaftsgüter, GewStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4964': {
        id: '4964',
        label: 'laufende Gebühren für Lizenzen',
        description: 'z.B. Software-Abonnements wie sevdesk',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4965': {
        id: '4965',
        label: 'Mietleasing bewegliche WG Betriebsausstattung',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4969': {
        id: '4969',
        label: 'Aufwand Abraum-/Abfallbeseitigung',
        description: 'Kosten für die Müllentsorgung',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4970': {
        id: '4970',
        label: 'Nebenkosten des Geldverkehrs',
        description: 'z.B. Kontogebühren und Gebühren für Kreditkarten',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4975': {
        id: '4975',
        label: 'Aufwendungen aus Anteilen an Kapitalgesellschaften §§ 3 Nr. 40 und 3c EStG bzw. § 8b Abs. 1 und 4 KStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4976': {
        id: '4976',
        label: 'Veräußerungskosten z.T. nicht abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4977': {
        id: '4977',
        label: 'Veräußerungskosten § 3 Nr. 40 EStG bzw. § 8b Abs. 3 KStG (bei Veräußerungsverlust)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4980': {
        id: '4980',
        label: 'Sonstiger Betriebsbedarf',
        description:
            'Kosten für sonstige Anschaffungen, die sich keiner Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4984': {
        id: '4984',
        label: 'Genossenschaftliche Rückvergütung an Mitunternehmer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4985': {
        id: '4985',
        label: 'Werkzeuge und Kleingeräte',
        description: 'Kosten für kleinere Anschaffungen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '4997': {
        id: '4997',
        label: 'Verwaltungskosten',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '8000': {
        id: '8000',
        label: 'Umsatzerlöse',
        description: 'Einnahmen aus dem Verkauf von Waren und Dienstleistungen',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8001': {
        id: '8001',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8002': {
        id: '8002',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8003': {
        id: '8003',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8004': {
        id: '8004',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8005': {
        id: '8005',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8006': {
        id: '8006',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8007': {
        id: '8007',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8008': {
        id: '8008',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8009': {
        id: '8009',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8010': {
        id: '8010',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8011': {
        id: '8011',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8012': {
        id: '8012',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8013': {
        id: '8013',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8014': {
        id: '8014',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8015': {
        id: '8015',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8016': {
        id: '8016',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8017': {
        id: '8017',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8018': {
        id: '8018',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8019': {
        id: '8019',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8020': {
        id: '8020',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8021': {
        id: '8021',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8022': {
        id: '8022',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8023': {
        id: '8023',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8024': {
        id: '8024',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8025': {
        id: '8025',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8026': {
        id: '8026',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8027': {
        id: '8027',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8028': {
        id: '8028',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8029': {
        id: '8029',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8030': {
        id: '8030',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8031': {
        id: '8031',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8032': {
        id: '8032',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8033': {
        id: '8033',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8034': {
        id: '8034',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8035': {
        id: '8035',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8036': {
        id: '8036',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8037': {
        id: '8037',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8038': {
        id: '8038',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8039': {
        id: '8039',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8040': {
        id: '8040',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8041': {
        id: '8041',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8042': {
        id: '8042',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8043': {
        id: '8043',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8044': {
        id: '8044',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8045': {
        id: '8045',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8046': {
        id: '8046',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8047': {
        id: '8047',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8048': {
        id: '8048',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8049': {
        id: '8049',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8050': {
        id: '8050',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8051': {
        id: '8051',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8052': {
        id: '8052',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8053': {
        id: '8053',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8054': {
        id: '8054',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8055': {
        id: '8055',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8056': {
        id: '8056',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8057': {
        id: '8057',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8058': {
        id: '8058',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8059': {
        id: '8059',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8060': {
        id: '8060',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8061': {
        id: '8061',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8062': {
        id: '8062',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8063': {
        id: '8063',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8064': {
        id: '8064',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8065': {
        id: '8065',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8066': {
        id: '8066',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8067': {
        id: '8067',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8068': {
        id: '8068',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8069': {
        id: '8069',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8070': {
        id: '8070',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8071': {
        id: '8071',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8072': {
        id: '8072',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8073': {
        id: '8073',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8074': {
        id: '8074',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8075': {
        id: '8075',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8076': {
        id: '8076',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8077': {
        id: '8077',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8078': {
        id: '8078',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8079': {
        id: '8079',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8080': {
        id: '8080',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8081': {
        id: '8081',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8082': {
        id: '8082',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8083': {
        id: '8083',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8084': {
        id: '8084',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8085': {
        id: '8085',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8086': {
        id: '8086',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8087': {
        id: '8087',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8088': {
        id: '8088',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8089': {
        id: '8089',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8090': {
        id: '8090',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8091': {
        id: '8091',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8092': {
        id: '8092',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8093': {
        id: '8093',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8094': {
        id: '8094',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8095': {
        id: '8095',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8096': {
        id: '8096',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8097': {
        id: '8097',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8098': {
        id: '8098',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8099': {
        id: '8099',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8100': {
        id: '8100',
        label: 'Steuerfreie Umsätze § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8101': {
        id: '8101',
        label: 'Steuerfreie Umsätze § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8102': {
        id: '8102',
        label: 'Steuerfreie Umsätze § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8103': {
        id: '8103',
        label: 'Steuerfreie Umsätze § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8104': {
        id: '8104',
        label: 'Steuerfreie Umsätze § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8110': {
        id: '8110',
        label: 'Sonstige steuerfreie Umsätze Inland',
        description: 'Steuerfreie Einnahmen die unter den § 4 UStG fallen',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8120': {
        id: '8120',
        label: 'Steuerfreie Erlöse Drittland',
        description: '',
        allowedTaxRules: [
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8125': {
        id: '8125',
        label: 'steuerfreie EU Erlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8191': {
        id: '8191',
        label: 'Umsätze nach §§ 25 und 25a UStG 19 %  USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8200': {
        id: '8200',
        label: 'Erlöse',
        description: 'Einnahmen aus dem Verkauf von Waren und Dienstleistungen',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8300': {
        id: '8300',
        label: 'Erlöse 7 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen mit 7 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8301': {
        id: '8301',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8302': {
        id: '8302',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8303': {
        id: '8303',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8304': {
        id: '8304',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8305': {
        id: '8305',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8306': {
        id: '8306',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8307': {
        id: '8307',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8308': {
        id: '8308',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8309': {
        id: '8309',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8334': {
        id: '8334',
        label: 'Erlöse 7 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen mit 7 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8337': {
        id: '8337',
        label: 'Erlöse aus Leistungen nach § 13 b UStG',
        description: 'Einnahmen für Umsätze nach § 13b z. B. bei Bauleistungen',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8338': {
        id: '8338',
        label: 'Nicht steuerbare Umsätze Drittland',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8400': {
        id: '8400',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8401': {
        id: '8401',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8402': {
        id: '8402',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8403': {
        id: '8403',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8404': {
        id: '8404',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8405': {
        id: '8405',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8406': {
        id: '8406',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8407': {
        id: '8407',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8408': {
        id: '8408',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8409': {
        id: '8409',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8410': {
        id: '8410',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8510': {
        id: '8510',
        label: 'Provisionsumsätze',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8514': {
        id: '8514',
        label: 'Provisionsumsätze steuerfrei § 4 Nr. 8ff',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8516': {
        id: '8516',
        label: 'Provisionsumsätze 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8519': {
        id: '8519',
        label: 'Provisionsumsätze 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8520': {
        id: '8520',
        label: 'Erlöse Abfallverwertung',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8540': {
        id: '8540',
        label: 'Erlöse Leergut',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8570': {
        id: '8570',
        label: 'Provisionen sonstige Erträge',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8574': {
        id: '8574',
        label: 'Sonstige Erträge aus Provisionen, Lizenzen und Patenten, steuerfrei § 4 Nr. 8 ff. UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8576': {
        id: '8576',
        label: 'sonstige Erträge aus Provisionen Lizenzen und Patenten 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8579': {
        id: '8579',
        label: 'sonstige Erträge aus Provisionen Lizenzen und Patenten 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8591': {
        id: '8591',
        label: 'Sachbezüge 7 %  USt (Waren)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8595': {
        id: '8595',
        label: 'Sachbezüge 19 % USt (Waren)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8603': {
        id: '8603',
        label: 'Sonstige betriebliche Erträge',
        description:
            'Einnahmen, die nicht den anderen Erlöskonten zugeordnet werden können',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8611': {
        id: '8611',
        label: 'Verrechnete sonstige Sachbezüge aus Kfz Gestellung 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8613': {
        id: '8613',
        label: 'Verrechnete sonstige Sachbezüge 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8625': {
        id: '8625',
        label: 'Sonst. Erträge betr. u. regelmäßig steuerfrei',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8640': {
        id: '8640',
        label: 'Sonstige Erträge betrieblich und regelmäßig 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8700': {
        id: '8700',
        label: 'Erlösschmälerungen',
        description: 'z. B. Rabatte',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8701': {
        id: '8701',
        label: 'Erlösschmälerungen steuerfrei § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8703': {
        id: '8703',
        label: 'Erlösschmälerungen für sonstige steuerfreie Umsätze ohne Vorsteuerabzug',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8704': {
        id: '8704',
        label: 'Erlösschmälerungen für sonstige steuerfreie Umsätze mit Vorsteuerabzug',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8710': {
        id: '8710',
        label: 'Erlösschmälerungen 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8720': {
        id: '8720',
        label: 'Erlösschmälerungen 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8730': {
        id: '8730',
        label: 'Gewährte Skonti',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8731': {
        id: '8731',
        label: 'Gewährte Skonti 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8736': {
        id: '8736',
        label: 'Gewährte Skonti 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8745': {
        id: '8745',
        label: 'Gewährte Skonti steuerpflichtige EU-Lieferungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8750': {
        id: '8750',
        label: 'Gewährte Boni 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8760': {
        id: '8760',
        label: 'Gewährte Boni 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8769': {
        id: '8769',
        label: 'Gewährte Boni',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8770': {
        id: '8770',
        label: 'Gewährte Rabatte',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8780': {
        id: '8780',
        label: 'Gewährte Rabatte 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8790': {
        id: '8790',
        label: 'Gewährte Rabatte 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8800': {
        id: '8800',
        label: 'Erlöse Sachanlagenverkäufe Buchverlust',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8801': {
        id: '8801',
        label: 'Erlöse aus Verkäufen Sachanlagenvermögen 19 % USt (bei Buchverlust)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8817': {
        id: '8817',
        label: 'Erlöse Verkäufe immaterielle Vermögensgegenstände, BV',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8820': {
        id: '8820',
        label: 'Erlöse aus Verkäufen Sachanlagevermögen 19 % USt (Bei Buchgewinn)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8829': {
        id: '8829',
        label: 'Erlöse Sachanlagenverkäufe Buchgewinn',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8837': {
        id: '8837',
        label: 'Erlöse aus Verkäufen immaterieller Vermögensgegenstände (bei Buchgewinn)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8910': {
        id: '8910',
        label: 'Entnahmen durch den Unternehmen für Zwecke außerhalb des Unternehmens 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8915': {
        id: '8915',
        label: 'Entnahme durch den Unternehmer für Zwecke außerhalb des Unternehmens (Waren) 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8919': {
        id: '8919',
        label: 'Entnahmen durch den Unternehmen für Zwecke außerhalb des Unternehmens ohne USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8920': {
        id: '8920',
        label: 'Verwendung von Gegenständen für Zwecke außerhalb des Unternehmens 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8921': {
        id: '8921',
        label: 'Verwendung von Gegenständen für Zwecke außerhalb des Unternehmens 19 % USt (KFZ Nutzung)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8922': {
        id: '8922',
        label: 'Verwendung von Gegenständen für Zwecke außerhalb des Unternehmens 19 % USt (Telefonnutzung)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8924': {
        id: '8924',
        label: 'Verwendung von Gegenständen für Zwecke außerhalb des Unternehmens o. USt (KFZ Nutzung)',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_REVENUE',
                id: 22,
                description: 'z.B. Durchlaufende Posten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8925': {
        id: '8925',
        label: 'Unentgeltliche Erbringung einer sonstigen Leistung 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8930': {
        id: '8930',
        label: 'Verwendung von Gegenständen für Zwecke außerhalb des Unternehmens 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8932': {
        id: '8932',
        label: 'Unentgeltliche Erbringung einer sonstigen Leistung 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8935': {
        id: '8935',
        label: 'Unentgeltliche Zuwendung von Gegenständen 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8940': {
        id: '8940',
        label: 'Unentgeltliche Zuwendung von Waren 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8945': {
        id: '8945',
        label: 'Unentgeltliche Zuwendung von Waren 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '8990': {
        id: '8990',
        label: 'andere aktivierte Eigenleistungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '9008': {
        id: '9008',
        label: 'Saldenvorträge Debitoren',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '9009': {
        id: '9009',
        label: 'Saldenvorträge Kreditoren',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
}
